export default __webpack_public_path__ + "static/media/meh-star.5e6fc850.svg";